
<template>
  <div class="chats" v-loading="loading">
    <div v-for="(mensaje, index) in mensajes" :key="index" class="chat"
      :class="{ 'chat-left': isComponent && mensaje.usuario_id != usuario_id || mensaje.rol == 1, 'chat-right': isComponent && mensaje.usuario_id == usuario_id ||  mensaje.rol == 2 }">

      <div class="chat-avatar">
        <avatar :name="'IA'" :src="isComponent ? mensaje.usuario.avatar : mensaje.avatar" :size="60" v-b-tooltip.hover="isComponent ? mensaje.usuario.fullname : mensaje.nombre" />
      </div>

      <div class="chat-body ">
        <div class="chat-content">

          <el-skeleton :rows="3" :loading="!(mensaje && mensaje.mensaje)" animated>
            <div v-html="mensaje.mensaje"></div>
            <small style="font-size:7pt">{{ isComponent ? mensaje.created_at : getFechaChat(mensaje.created_at) }}</small>
          </el-skeleton>

          <small class="text-muted" v-if="!isComponent && !mensaje.respondido && (mensaje.mensaje == null || mensaje.mensaje == '')">
            Estamos preparando una respuesta para ti, por favor espera un momento.
          </small>

          <b-button-group size="sm" class="d-block ms-0" v-if="!isComponent">
            <b-button v-show="mensaje.respondido" variant="dark" style="padding: .2rem;" title="Copiar" v-b-tooltip.hover @click="copiarMensaje(mensaje.mensaje)">
              <i class="fas fa-copy"></i>
            </b-button>
          </b-button-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

  import { toRefs, computed, ref, onMounted,inject } from 'vue'
  import { getFecha, getFechaChat } from '@utils/utils';
  import useRootStore from '@/store/root'
  import {storeToRefs} from 'pinia';
  import { useClipboard } from '@vueuse/core';
  import useUsuarioStore from '@/store/usuario';

  const usuario_store = useUsuarioStore();
  const {usuario_id } = storeToRefs(usuario_store);
  const root_store = useRootStore();
  const {loading} = storeToRefs(root_store);


  const props = defineProps({
    actions:{
      type:Object,
      default:()=>({})
    },
    esperandoRespuesta:{
      type:Boolean,
      default:false
    },
    refChatLogPS:{
      type:Object,
      default:null
    },
    isComponent:{
      type:Boolean,
      default:false
    }
  });



const { copy, copied,text } = useClipboard();

const copiarMensaje = (msj) => {
  copy(msj).then(() => {
    toast.success("Mensaje copiado al portapapeles");
  });
 
}


const { actions } = toRefs(props);
  const index = ref(null)
 

    const {
      mensajes,
      chat:chatbot,
    } = actions.value;



    const getNameUserChat = (msj) => {
      if(msj.origen == 1){
        return 'Concierge Digital';
      }
      return 'User';
    }


</script>

<style lang="scss">

pre{
  background-color: #0d0d0f !important;
  padding: 2rem;
  border-radius: 7px;
}
.chat{

  .chat-body{
    margin:0px;
  }
}
.chat-content {
  position: relative;
  transition: all 3s ease;
  min-width: 200px;
  max-width:92% !important;

  p{
    font-size:10pt !important;
  }

  .option-mensaje-trash {
    display: none;
    position: absolute;
    top: -7px;
    right: -15px;
    transition: all 1s ease;
  }

  &:hover>.option-mensaje-trash {
    display: flex;
    transform: scale(1.5);
  }
}

.esperando-respuesta{
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top:1rem;
  .spinner-grow {
    margin: 0px 5px;
  }
}

.scroll-area {
  // height: 100%;
  overflow-y: auto;
  padding: 0 0px;
  margin: 0 0rem;
  width: 100%;
}


@media (min-width:768px){
  .chat-content{
    min-width: 420px;
  }
}
</style>
